import { Component, OnInit, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import * as EXIF from 'exif-js';
@Component({
  selector: 'app-browse',
  templateUrl: './browse.component.html',
  styleUrls: ['./browse.component.scss']
})
export class BrowseComponent implements OnInit {

  @ViewChild('c') canvas: ElementRef;
  ctx: CanvasRenderingContext2D;

  @Input()
  primaryColor: string;
  @Input()
  secondaryColor: string;

  filename: string;
  fileTypeError: boolean;
  uploadError: boolean;
  acceptedFileTypes = [".jpg", ".jpeg", ".gif", ".png", ".bmp"];

  @Output() fileSelected = new EventEmitter<string>();
  exif: EXIF;
  loading = false;

  constructor() {}

  ngOnInit() {
    this.ctx = (<HTMLCanvasElement>this.canvas.nativeElement).getContext('2d');
    this.fileTypeError = false;
  }

  triggerFileInput($event) : void{
    let input = <HTMLInputElement>document.getElementById('file-input');
    input.click();
  }

  changeListener($event) : void {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    this.loading = true;
    let file:File = inputValue.files[0];
    let temp = file.name.split(".");
    let fileExt = "."+temp[temp.length-1].toLowerCase();
    if(this.acceptedFileTypes.findIndex(t => t == fileExt)>-1){
      this.fileTypeError = false;
      var myReader:FileReader = new FileReader();
      myReader.readAsDataURL(file);
      myReader.onloadend = (e) => {
        let comp = this;
        this.filename = file.name;
        let imageData = myReader.result;
        EXIF.getData(file, function(){
          if(!this.error){
            comp.uploadError = false;
            let exifOrientation = EXIF.getTag(this, "Orientation");
            comp.transformBase64Image(imageData, exifOrientation, fileExt);
          }
          else{
            comp.uploadError = true;
            comp.filename = null;
            comp.loading = false;
          }
        });
      }
    }
    else{
      this.fileTypeError = true;
      this.loading = false;
    }
  }

  //should not be called outside interval where orientation = [2,8], but values 1 & default are still supported just in case
  transformBase64Image(imgData: string, orientation: number, fileExt: string): void{
    let canvasObj = (<HTMLCanvasElement>this.canvas.nativeElement);
    let image = new Image();
    let comp = this;
    let scale = 1;
    const MAX_SIZE = 2000;
    image.src = imgData;
    image.onload = function(){

      let maxDim = image.width > image.height ? image.width : image.height;
      if (maxDim > MAX_SIZE) scale = MAX_SIZE / maxDim;

      switch(orientation){
        case 1:{ //base
          canvasObj.width = image.width*scale;
          canvasObj.height = image.height*scale;
          break;
        }
        case 2:{ // flip horiz
          canvasObj.width = image.width*scale;
          canvasObj.height = image.height*scale;
          comp.ctx.translate(canvasObj.width, 0);
          comp.ctx.scale(-1, 1);
          break;
        }
        case 3:{ // rotate 180
          canvasObj.width = image.width*scale;
          canvasObj.height = image.height*scale;
          comp.ctx.translate(canvasObj.width, canvasObj.height);
          comp.ctx.rotate(180 * Math.PI / 180);
          break;
        }
        case 4:{ // flip vert
          canvasObj.width = image.width*scale;
          canvasObj.height = image.height*scale;
          comp.ctx.translate(0, canvasObj.height);
          comp.ctx.scale(1, -1);
          break;
        }
        case 5:{ // transpose
          canvasObj.width = image.height*scale;
          canvasObj.height = image.width*scale;
          comp.ctx.rotate(-90 * Math.PI / 180);
          comp.ctx.scale(-1, 1);
          break;
        }
        case 6:{ // rotate 90
          canvasObj.width = image.height*scale;
          canvasObj.height = image.width*scale;
          comp.ctx.rotate(90 * Math.PI / 180);
          comp.ctx.translate(0, -canvasObj.width);
          break;
        }
        case 7:{ // transverse
          canvasObj.width = image.height*scale;
          canvasObj.height = image.width*scale;
          comp.ctx.rotate(90 * Math.PI / 180);
          comp.ctx.scale(-1, 1);
          comp.ctx.translate(-canvasObj.height, -canvasObj.width);
          break;
        }
        case 8:{ // rotate 270
          canvasObj.width = image.height*scale;
          canvasObj.height = image.width*scale;
          comp.ctx.rotate(-90 * Math.PI / 180);
          comp.ctx.translate(-canvasObj.height, 0);
          break;
        }
        default:{ //base
          canvasObj.width = image.width*scale;
          canvasObj.height = image.height*scale;
          break;
        }
      }
      comp.ctx.scale(scale, scale);
      comp.ctx.drawImage(image,0,0);

      let data: string;
      if(fileExt == ".png" || fileExt == ".gif") data = canvasObj.toDataURL("image/png"); // preserves transparency
      else data = canvasObj.toDataURL("image/jpeg");
      comp.fileSelected.emit(data);
      comp.loading = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/browse/browse.component.ts